import { I18n } from "@vwpfs/mary-air-lib/utils/I18n/index";

export interface I18nTextProps {
    key: string | I18nTextProps;
    dflt?: string;
    vars?: {[key: string]: string};
}

export const getText = (key: string | I18nTextProps,
                        dflt?: string, vars?: {[key: string]: string}): string | undefined => {
    const props = {
        key: typeof key === "string" ? key : key.key as string,
        dflt: typeof key === "string" ? dflt : key.dflt,
        vars: typeof key === "string" ? vars : key.vars,
    };

    let value: string | undefined = I18n.get(props.key, props.dflt);
    if (props.vars && value) {
        Object.keys(props.vars).forEach((k) => {
            if (value){
                value = value.replace(`{{${k}}}`, props.vars ? props.vars[k] : "");
            }
        });
    }
    return value;
};

export const getReactNode = (key: string, dflt?: string | React.ReactNode): React.ReactNode => {
    const stringDefault = typeof dflt === "string" ? dflt : undefined;
    const result = I18n.get(key, stringDefault);
    return result ?? dflt;
};
